import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../api';

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/dashboard').then(r => setStats(r.data)).finally(() => setLoading(false));
  }, []);

  const fmt = n => `PKR ${(n || 0).toLocaleString()}`;

  const cards = stats ? [
    { icon: '🎓', label: 'Total Students', value: stats.totalStudents, color: '#ebf8ff', iconBg: '#3182ce' },
    { icon: '🏠', label: 'Occupied Rooms', value: `${stats.occupiedRooms} / 60`, color: '#fff5f5', iconBg: '#e53e3e' },
    { icon: '✅', label: 'Available Rooms', value: stats.availableRooms, color: '#f0fff4', iconBg: '#38a169' },
    { icon: '💰', label: 'Monthly Income', value: fmt(stats.monthlyIncome), color: '#f0fff4', iconBg: '#276749' },
    { icon: '💸', label: 'Monthly Expenses', value: fmt(stats.monthlyExpenses), color: '#fff5f5', iconBg: '#c53030' },
    { icon: '⚠️', label: 'Pending Fees', value: fmt(stats.pendingFees), color: '#fffaf0', iconBg: '#d69e2e' },
  ] : [];

  return (
    <Layout title="Dashboard">
      {loading ? (
        <div className="text-center" style={{ padding: 60, color: '#718096' }}>Loading...</div>
      ) : (
        <>
          <div style={{ marginBottom: 20 }}>
            <h2 style={{ fontSize: 16, color: '#4a5568' }}>
              📅 {stats?.currentMonth} — Overview
            </h2>
          </div>

          <div className="stats-grid">
            {cards.map((c, i) => (
              <div key={i} className="stat-card" style={{ background: c.color }}>
                <div className="stat-icon" style={{ background: c.iconBg, color: '#fff' }}>
                  {c.icon}
                </div>
                <div className="stat-info">
                  <h3 style={{ fontSize: typeof c.value === 'string' && c.value.startsWith('PKR') ? 15 : 24 }}>
                    {c.value}
                  </h3>
                  <p>{c.label}</p>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20 }}>
            <div className="card">
              <div className="card-header">
                <h3 className="card-title">📊 Financial Summary</h3>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <Row label="Fee Income" value={fmt(stats?.monthlyIncome)} color="#276749" />
                <Row label="Total Expenses" value={fmt(stats?.monthlyExpenses)} color="#c53030" />
                <Row
                  label="Net Balance"
                  value={fmt((stats?.monthlyIncome || 0) - (stats?.monthlyExpenses || 0))}
                  color={(stats?.monthlyIncome || 0) >= (stats?.monthlyExpenses || 0) ? '#276749' : '#c53030'}
                />
                <Row label="Pending Fees" value={fmt(stats?.pendingFees)} color="#d69e2e" />
              </div>
            </div>

            <div className="card">
              <div className="card-header">
                <h3 className="card-title">🏠 Room Status</h3>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <Row label="Total Rooms" value="60" />
                <Row label="Occupied" value={stats?.occupiedRooms} color="#c53030" />
                <Row label="Available" value={stats?.availableRooms} color="#276749" />
                <div style={{ marginTop: 8 }}>
                  <div style={{ background: '#f0f4f8', borderRadius: 6, height: 12, overflow: 'hidden' }}>
                    <div
                      style={{
                        width: `${((stats?.occupiedRooms || 0) / 60) * 100}%`,
                        background: '#e53e3e',
                        height: '100%',
                        borderRadius: 6,
                        transition: 'width 0.3s'
                      }}
                    />
                  </div>
                  <p style={{ fontSize: 11, color: '#718096', marginTop: 4 }}>
                    {Math.round(((stats?.occupiedRooms || 0) / 60) * 100)}% occupied
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}

function Row({ label, value, color }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f0f4f8' }}>
      <span style={{ fontSize: 13, color: '#718096' }}>{label}</span>
      <span style={{ fontSize: 13, fontWeight: 600, color: color || '#2d3748' }}>{value}</span>
    </div>
  );
}
